export default __webpack_public_path__ + "static/media/ian-vertical.b2e79e48.png";